export enum ExpedienteEstados {
  ingresada = 1,
  en_validacion_datos = 2,
  pendiente_notificacion_inicial = 3,
  notificado = 4,
  pendiente_evaluacion_medica = 5,
  en_comision_medica = 6,
  resolucion_emitida = 7,
  en_apelacion = 8,
  cierre_administrativo = 9,
  rechazado = 10,
  pendiente_verificacion = 11
}

export default ExpedienteEstados;